import { timesheetLhbRecords } from "constants/timesheet";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { lhbRecordsList } from "constants/lhbRecords";

export const getTimeSheetLhbRecords = async (dispatch, pageNum) => {
  try {
    const res = await API.timesheet_lhb_records_list(pageNum);
    dispatch({ type: timesheetLhbRecords, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: timesheetLhbRecords,
      payload: error?.response?.data || error,
    });
  }
};

export const addTimeSheetRecord = async (bodyData) => {
  try {
    const res = await API.add_timesheet_records(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getTimeSheetRecordDetailById = async (id) => {
  try {
    const res = await API.get_timesheet_records_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateTimesheetRecordById = async (id, bodyData) => {
  try {
    const res = await API.edit_LHB_records(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteLhbRecordById = async (id) => {
  try {
    const res = await API.delete_lhb_record_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getLhbRecordsList = async (dispatch) => {
  try {
    const res = await API.get_lhbRecords_list();
    dispatch({
      type: lhbRecordsList,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: lhbRecordsList,
      payload: error?.response?.data || error,
    });
  }
};
